module.exports = __webpack_public_path__ + "img/hut_no.a5e77d16.png";